export default __webpack_public_path__ + "static/media/great-post-fren.24cae43f.jpeg";